import { Assets } from '~/assets.g/assets';

export interface PersonaRoleBadgeProps {
  role?: string;
  isSidebarOpen: boolean;
}

export function PersonaRoleBadge({ role, isSidebarOpen }: PersonaRoleBadgeProps) {
  return (
    <div
      className={`personaRole bodyMdSemiBold flex rounded-lg bg-primaryUltraDark text-neutralExtraLight transition-all duration-300 ease-in-out ${
        isSidebarOpen
          ? 'mx-3 mb-4 mt-1 h-12 flex-row items-center justify-start px-3 py-2'
          : 'mx-auto mb-4 mt-1 h-14 w-14 flex-col items-center justify-center p-3'
      }`}
    >
      <span
        className={`relative h-5 w-5 flex-shrink-0 transition-all duration-300 ease-in-out ${isSidebarOpen ? 'mr-3' : 'mr-0'}`}
      >
        <img
          className="absolute left-0 top-0 h-full w-full"
          src={Assets.images.persona}
          alt="persona"
        />
      </span>

      <p
        className={`whitespace-nowrap text-center transition-all duration-200 ease-in-out ${isSidebarOpen ? 'opacity-100' : 'h-0 scale-0 opacity-0'}`}
        style={{ opacity: isSidebarOpen ? '1' : '0' }}
      >
        {role}
      </p>
    </div>
  );
}
